import type { APIReqBody, APIReqConfig, APIReqOptions, APIResBody } from 'server/services/recommendation';
import recsAxios from './recsAxios';

export const getRecommendations = async (configs: APIReqConfig[], options: APIReqOptions) => {
  try {
    const res = await recsAxios().post<APIResBody>('/recommendations', { configs, options } satisfies APIReqBody);
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default {};
